/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import EmployeeRole from "components/employeeRoles/EmployeeRole";
import Pagination from "react-js-pagination";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";

class EmployeeRoles extends Component {
  state = {
    filteredRolesData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
    dataFetched: false,
    sort_by: "trEmployee",
    sort_dir: "desc",
  };

  settings = {
    itemsPerPage: 10,
  };

  componentDidMount() {
    this.setState({ filteredRolesData: this.props.data.rolesOfEmployeeItems });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        filteredRolesData: this.props.data.rolesOfEmployeeItems,
      });
    }

    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredRolesData: this.props.data.rolesOfEmployeeItems.filter(
          (item) => {
            return (
              Helpers.getTurkishCharaterFixedList(item.employee.name).includes(
                Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
              ) ||
              Helpers.getTurkishCharaterFixedList(item.role.name).includes(
                Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
              )
            );
          }
        ),
        activePage: 1,
      });
    }
  }

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  renderSearchBar = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="tableSearch"
            id="tableSearch"
            className="form-control"
            placeholder={i18next.t("10053")}
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterTerm}
          />
        </div>
      </div>
    );
  };

  renderHeaderToolbar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "20px",
          marginLeft: "20px",
        }}
      >
        {this.renderSearchBar()}

        <Pagination
          hideFirstLastPages={true}
          prevPageText={i18next.t(10110)}
          nextPageText={i18next.t(10111)}
          hideDisabled={true}
          hideNavigation={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredRolesData?.length > 0
              ? this.state.filteredRolesData.length
              : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  renderFooterToolbar = () => {
    return (
      <div className="table-footer-toolbar">
        {/* <button className="export-button" onClick={this.handleExportCSV}>
          <Trans desc="Dışa Aktar">10113</Trans>
        </button> */}
      </div>
    );
  };

  trEmployee = "";
  trRole = "";
  trRoleStatus = "";
  trDealer = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trEmployee = "";
    this.trRole = "";
    this.trRoleStatus = "";
    this.trDealer = "";

    switch (this.state.sort_by) {
      case "trEmployee":
        this.trEmployee = `_${this.state.sort_dir}`;
        break;
      case "trRole":
        this.trRole = `_${this.state.sort_dir}`;
        break;
      case "trRoleStatus":
        this.trRoleStatus = `_${this.state.sort_dir}`;
        break;
      case "trDealer":
        this.trDealer = `_${this.state.sort_dir}`;
        break;
      default:
        this.trEmployee = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = (start, end) => {
    const sorted = this.state.filteredRolesData.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trEmployee":
          return this.state.sort_dir === "desc"
            ? a.employee?.name.localeCompare(b.employee?.name)
            : b.employee?.name.localeCompare(a.employee?.name);
        case "trRole":
          return this.state.sort_dir === "desc"
            ? a.role?.name.localeCompare(b.role?.name)
            : b.role?.name.localeCompare(a.role?.name);
        case "trRoleStatus":
          return this.state.sort_dir === "desc"
            ? a.roleStatus.localeCompare(b.roleStatus)
            : b.roleStatus.localeCompare(a.roleStatus);
        case "trDealer":
          return this.state.sort_dir === "desc"
            ? a.dealer?.name.localeCompare(b.dealer?.name)
            : b.dealer?.name.localeCompare(a.dealer?.name);
        default:
          return this.state.sort_dir === "desc"
            ? a.employee?.name.localeCompare(b.employee?.name)
            : b.employee?.name.localeCompare(a.employee?.name);
      }
    });

    return sorted.slice(start, end).map((role) => {
      return (
        <EmployeeRole key={role.key} role={role} refresh={this.props.refresh} />
      );
    });
  };

  render() {
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    this.setSotingClassNames();

    return (
      <>
        {this.props.spinner}
        <div>{this.renderHeaderToolbar()}</div>
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
          id="calisanRolleri"
          style={{ display: "block" }}
        >
          <table
            className="table display responsive dataTable no-footer dtr-none collapsed"
            id="dataTablePersonel"
          >
            <thead>
              <tr>
                <th
                  onClick={() => this.reOrder("trEmployee")}
                  className={`all sorting${this.trEmployee}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Ad Soyad">10545</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trRole")}
                  className={`all sorting${this.trRole}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Rol">10546</Trans>
                  </div>
                </th>
                <DesktopBreakpoint>
                  <th
                    onClick={() => this.reOrder("trRoleStatus")}
                    className={`desktop sorting${this.trRoleStatus}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Durum">10547</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trDealer")}
                    className={`desktop sorting${this.trDealer}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Bayi">10733</Trans>
                    </div>
                  </th>
                  <th className="none"></th>
                </DesktopBreakpoint>
              </tr>
            </thead>
            <tbody>{this.renderData(start, end)}</tbody>
          </table>
        </div>
        <div>
          <hr />
          {this.renderFooterToolbar()}
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ application }) => {
  return {
    application,
  };
};

export default connect(
  mapStateToProps,
  {}
)(containsLongRunningProcess(requireAuth(EmployeeRoles)));
